<template>
	<div style="position:relative;display:inline-block;max-width:220px;">
		<div class="input-group text-right">
			<div class="input-group-prepend">
				<span class="input-group-text fa fa-clock-o"></span>
			</div>
			<input type="text" class="form-control" :value="tiempoCrono" disabled="true" style="width:90px;">
			<div class="input-group-btn">
				<button class="btn btn-default" @click="startCrono()" v-if="!hCrono">
					<span class="fa fa-play"></span>
				</button>
				<button class="btn btn-default" @click="pauseCrono" v-if="!momentoPause && hCrono">
					<span class="fa fa-pause"></span>
				</button>
				<button class="btn btn-default" @click="resetCrono" v-if="momentoPause">
					<span class="fa fa-stop"></span>
				</button>
				<button class="btn btn-success" v-if="momentoPause" @click="confirmar">
					<span class="fa fa-check"></span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			inicioCrono: 0,
			tiempoCrono: '0:00:00.000',
			offsetCrono: 0,
			momentoPause: null,
			hCrono: null,
			statusCrono: 'stop',
			tiempoActual: null
		}
	},

	methods: {
		startCrono () {
			if (this.hCrono) {
				return
			}

			this.hCrono = window.setInterval(() => {
				if (!this.inicioCrono) {
					this.inicioCrono = new Date().getTime()
				}

				const ahora = new Date().getTime()

				if (this.momentoPause) {
					this.offsetCrono += ahora - this.momentoPause
					this.momentoPause = null
				}

				this.tiempoActual = new Date(ahora - this.inicioCrono - this.offsetCrono)
				const hora = this.tiempoActual.getHours() - 1
				const minutos = (this.tiempoActual.getMinutes() < 10) ? '0' + this.tiempoActual.getMinutes() : this.tiempoActual.getMinutes()
				const segundos = (this.tiempoActual.getSeconds() < 10) ? '0' + this.tiempoActual.getSeconds() : this.tiempoActual.getSeconds()
				let milisec = this.tiempoActual.getMilliseconds()
				milisec = (milisec < 100) ? (milisec < 10) ? '00' + milisec : '0' + milisec : milisec

				this.tiempoCrono = hora + ':' + minutos + ':' + segundos + '.' + milisec
			}, 10)
		},

		resetCrono () {
			if (!this.momentoPause) {
				return
			}
			if (this.hCrono) {
				window.clearInterval(this.hCrono)
			}
			this.tiempoCrono = '0:00:00.000'
			window.clearInterval(this.hCrono)
			this.hCrono = null
			this.offsetCrono = 0
			this.inicioCrono = null
			this.momentoPause = null
		},

		pauseCrono () {
			this.momentoPause = new Date().getTime()
			window.clearInterval(this.hCrono)
			this.hCrono = null
		},

		confirmar () {
			const total = Math.round((this.tiempoActual.getTime() + 2000) / 1000)
			const horas = (total < 3600) ? 0 : Math.floor(total / 3600)
			const minutos = ((total % 3600) < 0) ? 0 : Math.floor((total % 3600) / 60)
			const segundos = (total < 60) ? total : (total < 3600) ? Math.floor(total % 60) : Math.floor(total % 3600)

			let cadena = ''
			if (horas > 0) {
				cadena += horas + ' horas '
			}
			if (minutos > 0) {
				cadena += minutos + ' minutos '
			}

			cadena += segundos + ' segundos.'

			this.$store.commit('alertas/confirm', {
				titulo: 'Confirmar tiempo',
				mensaje: `¿Confirmas este tiempo como una estimación valida de duración de la cuña?
				A este tiempo se le sumarán 2 segundos en concepto de ajuste por locución y efectos.
				Tiempo total estimado: <b>${cadena}</b>`,
				callback: (acepta) => {
					if (acepta) {
						this.$emit('tiempo', total)
						this.resetCrono()
					}
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/cronometro.vue